import React, { useContext, useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import Group from 'components/utils/Group'
import LineUsersAltIcon from 'LuxKit/Icons/line/LineUsersAltIcon'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import AssistChip from 'LuxKit/Chips/AssistChip'
import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { generateRoomOccupants } from 'lib/offer/occupancyUtils'

interface MappedStateProps {
  businessAccount?: App.BusinessTraveller.CurrentBusinessAccount
}

interface Props {
  className?: string
}

function BusinessTravellerSelectHotelsOfferPageMobileDisabled(props: Props & MappedStateProps) {
  const {
    className,
    businessAccount,
  } = props

  // Ensure rooms are set in OfferPage context for the traveller role (1 traveller = 1 room).
  const { rooms } = useContext(OfferPageStateContext)
  const offerPageDispatch = useOfferPageDispatch()
  useEffect(() => {
    if (!rooms) {
      offerPageDispatch({ type: OfferPageActions.setRooms, rooms: [generateRoomOccupants()] })
    }
  }, [rooms, offerPageDispatch])

  const travellerLabel = useMemo(() => {
    if (!businessAccount?.employee) {
      return '1 adult'
    }
    const { firstName = '', lastName = '' } = businessAccount.employee
    const name = `${firstName} ${lastName}`.trim()
    return name || '1 adult'
  }, [businessAccount?.employee])

  return (
    <Group className={className} direction="horizontal" gap={8} wrap="wrap">
      <AssistChip
        data-testid="multi-room-travellers-select"
        variant="outline"
        size="medium"
        startIcon={<LineUsersAltIcon />}
        disabled
      >
        {travellerLabel}
      </AssistChip>
      <AssistChip
        data-testid="multi-room-rooms-select"
        variant="outline"
        size="medium"
        startIcon={<LineBedIcon />}
        disabled
      >
        1 room
      </AssistChip>
    </Group>
  )
}

export default connect<MappedStateProps, {}, Props, App.State>((state) => {
  return {
    businessAccount: state.businessTraveller.currentBusinessAccount,
  }
})(BusinessTravellerSelectHotelsOfferPageMobileDisabled)
